import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { UpperCaseDirective } from './upper-case.directive';
import { NoWhitespaceDirective } from './no-whitespace.directive';
import { CurrencyInputMaskDirective } from './currency-input-mask.directive';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [CurrencyInputMaskDirective, NoWhitespaceDirective, UpperCaseDirective],
  exports: [CurrencyInputMaskDirective, NoWhitespaceDirective, UpperCaseDirective]
})
export class AppDirectivesModule {}
